import axios from 'axios'
import ENV from './env'
import Swal from 'sweetalert2'

const axiosReq = () => {
  const baseURL = ENV.REACT_APP_BASE_URL
  // const baseURL = '/api';
  const headers: any = { 'Content-Type': 'application/json' }

  const axiosInstance = axios.create({
    baseURL,
    headers,
    timeout: 100000
  })

  axiosInstance.interceptors.response.use(
    async (response) =>
      await new Promise((resolve) => {
        resolve(response)
      }),
    async (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: err.message
      })
      if (!err.response) {
        return await new Promise((resolve, reject) => {
          reject(err)
        })
      }
      if (err.response.status === 401) {
        return await new Promise((resolve, reject) => {
          reject(err)
        })
      }
      return await new Promise((resolve, reject) => {
        // message.error(err.response?.data?.message)
        reject(err)
      })
    }
  )
  return axiosInstance
}
export default axiosReq
